import { Asset, Entry } from 'contentful';

import InfoCard from 'components/InfoCard';

type Feature = {
  description: string;
  image: Asset;
  title: string;
};

type Props = {
  title: string;
  subtitle: string;
  features: Entry<Feature>[];
};

export default function FeaturesBlock({ title, subtitle, features }: Props) {
  const features1 = features.slice(0, features.length / 2);
  const features2 = features.slice(features.length / 2);
  return (
    <section className="py-24">
      <div className="mx-auto mb-16 max-w-7xl px-6">
        <h2 className="text-r-3xl text-center font-bold">{title}</h2>
        <p className="text-r-lg m-auto mt-8 max-w-3xl  text-center">
          {subtitle}
        </p>
      </div>
      <div className="mx-auto flex max-w-7xl flex-col gap-8 px-6 md:flex-row">
        <div className="flex-1">
          <div className="flex flex-col gap-10 pt-10">
            {features1.map((feature) => (
              <InfoCard key={feature.sys.id} card={feature} />
            ))}
          </div>
        </div>
        <div className="flex-1">
          <div className="flex flex-col gap-10 pt-10">
            {features2.map((feature) => (
              <InfoCard key={feature.sys.id} card={feature} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
